import { z } from 'zod';

export const EMAIL_EXTRACTION_TYPES = ['otp', 'magic-link', 'custom-extraction'] as const;
export const zExtractionType = z.enum(EMAIL_EXTRACTION_TYPES).optional();

export type EmailExtractionType = z.infer<typeof zExtractionType>;
